import React, {useState, useEffect} from "react";
import {db} from "../config/firebase-config";
import {
  collection,
  doc,
  addDoc,
  setDoc,
  getDoc,
  where,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import moment from "moment";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import MsgBox from "./MsgBox";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import useAuthorization from "../auth/useAuthorization";
import {STATUS, brauchtFunkkennungUndDienstort} from "../utils/status";

/**
 * Ein verweigertes Speichern darf nicht still verschwinden: Sonst hielte der
 * Nutzer den Statuswechsel für erledigt, obwohl weder Fahrzeug noch Protokoll
 * geschrieben wurden.
 */
const speicherfehlerText = (fehler) => {
  if (fehler?.code === "permission-denied") {
    return "Keine Berechtigung zum Speichern. Die Änderung wurde nicht oder nicht vollständig übernommen.";
  }

  return "Die Änderung konnte nicht oder nicht vollständig gespeichert werden.";
};

const ModalFahrzeug = (props) => {
  const {canWrite} = useAuthorization();
  const today = new Date();

  const [funkkennungen, setFunkkennungen] = useState([]);
  const [standorte, setStandorte] = useState([]);
  const [funkkennung, setFunkkennung] = useState("");
  const [standort, setStandort] = useState("");
  const [bemerkung, setBemerkung] = useState("");
  const [id, setId] = useState("");
  const [funkkennungAkt, setFunkkennungAkt] = useState("");
  const [needFunkkennung, setNeedFunkkennung] = useState();
  const [needDienstort, setNeedDienstort] = useState();
  const [standortTyp, setStandortTyp] = useState("");
  const [dataError, setDataError] = useState(true);
  const [funkkennungError, setFunkkennungError] = useState(true);
  const [standortError, setStandortError] = useState(true);
  const [bemerkungError, setBemerkungError] = useState(true);
  const [bemerkungChanged, setBemerkungChanged] = useState(false);
  const [kilometer, setKilometer] = useState("");
  const [speichert, setSpeichert] = useState(false);
  const [speicherFehler, setSpeicherFehler] = useState("");
  // Zielstatus: vorbelegt mit der Drag-Zielspalte bzw. dem aktuellen Status,
  // im Dialog änderbar. Alle Regeln unten hängen an ihm.
  const [status, setStatus] = useState("");

  const [desDate, setDesDate] = useState();

  const funkkennungenRef = collection(db, "funkkennungen");
  const standorteRef = collection(db, "standorte");
  const protokollRef = collection(db, "protokoll");

  useEffect(() => {
    const queryFunkkennungen = query(funkkennungenRef, orderBy("bezeichnung"));

    const unsubscribe = onSnapshot(queryFunkkennungen, (snapshot) => {
      let funkkennungen = [];
      snapshot.forEach((doc) => {
        funkkennungen.push({...doc.data(), id: doc.id});
      });
      setFunkkennungen(funkkennungen);
    });

    const queryStandorte = query(standorteRef, orderBy("bezeichnung"));

    const unsubscribeStandorte = onSnapshot(queryStandorte, (snapshot) => {
      let standorte = [];
      snapshot.forEach((doc) => {
        standorte.push({...doc.data(), id: doc.id});
      });
      setStandorte(standorte);
    });

    return () => {
      unsubscribe();
      unsubscribeStandorte();
    };
  }, []);

  useEffect(() => {
    // console.log("props.funkkennung", props.funkkennung);
    setFunkkennung(props.funkkennung);
  }, [props.funkkennung]);

  // Vorbelegen nur beim Öffnen: Die Fahrzeugseite reicht ein Live-Objekt
  // durch, und ein Snapshot soll laufende Eingaben nicht überschreiben. Ein
  // abgebrochener Dialog zeigt beim nächsten Öffnen wieder den Bestand.
  useEffect(() => {
    if (!props.showModal) {
      return;
    }

    setStatus(props.target || props.fahrzeug.status);
    setKilometer(props.fahrzeug.kilometerstand || "");
    if (props.fahrzeug.desDate) {
      setDesDate(new Date(props.fahrzeug.desDate.seconds * 1000).toString());
    } else {
      setDesDate(new Date().toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showModal, props.target, props.fahrzeug.id]);

  useEffect(() => {
    // Plausibilitätsprüfung Funkrufkennung

    if (props.showModal) {
      if (brauchtFunkkennungUndDienstort(status)) setNeedFunkkennung(true);
      else {
        setNeedFunkkennung(false);
      }

      if (needFunkkennung && funkkennung === "") {
        // setNeedFunkkennung(true);

        setFunkkennungError(true);
      } else {
        setFunkkennungError(false);
      }
    }
  }, [props.showModal, status, needFunkkennung, funkkennung]);

  useEffect(() => {
    // Plausibilitätsprüfung Dienstort

    if (props.showModal) {
      if (brauchtFunkkennungUndDienstort(status)) setNeedDienstort(true);
      else {
        setNeedDienstort(false);
      }

      standorte.forEach((standort) => {
        if (standort.bezeichnung === props.standort)
          setStandortTyp(standort.typ);
      });

      if (needDienstort && standortTyp !== "Dienstort") {
        // setNeedFunkkennung(true);

        setStandortError(true);
      } else {
        setStandortError(false);
      }
    }
  }, [
    status,
    needDienstort,
    props.standort,
    standorte,
    standortTyp,
    props.showModal,
  ]);

  useEffect(() => {
    if (!bemerkungChanged || props.bemerkung === "") {
      setBemerkungError(true);
    } else {
      setBemerkungError(false);
    }
  }, [bemerkungChanged, props.bemerkung]);

  const changeKm = (e) => {
    let valueTmp = e.target.value;

    const numericString = valueTmp.replace(/\D/g, "");

    // Wenn der String leer ist, gib eine leere Zeichenkette zurück
    if (numericString === "") return "";

    // Wandelt die Zahl in einen Integer um
    const number = parseInt(numericString, 10);

    setKilometer(number.toLocaleString("de-DE"));
  };

  const updateFahrzeug = () => {
    const docRef = doc(db, "fahrzeuge", props.id);

    let date = new Date();
    const localDate = date.toLocaleString();

    const newStatus = status !== props.fahrzeug.status;

    let funkkennungAltTmp = props.fahrzeug.funkkennung;
    if (funkkennung === funkkennungAltTmp) {
      // console.log("funkkenung unverändert (fahrzeug)", props.fahrzeug);
      if (props.fahrzeug.funkkennungAlt) {
        funkkennungAltTmp = props.fahrzeug.funkkennungAlt;
      } else {
        funkkennungAltTmp = "";
      }
    }

    let funkkennungTmp = funkkennung;
    if (!needFunkkennung) {
      funkkennungTmp = "";
      funkkennungAltTmp = props.fahrzeug.funkkennung;
    }

    let data = {};
    if (newStatus) {
      data = {
        bemerkung: props.bemerkung,
        funkkennung: funkkennungTmp,
        funkkennungAlt: funkkennungAltTmp,
        standort: props.standort,
        letztesUpdate: localDate,
        status,
        desDate: new Date(desDate),
        kilometerstand: kilometer,
      };
    } else {
      data = {
        bemerkung: props.bemerkung,
        funkkennung: funkkennungTmp,
        funkkennungAlt: funkkennungAltTmp,
        standort: props.standort,
        status,
        desDate: new Date(desDate),
        kilometerstand: kilometer,
      };
    }

    return setDoc(docRef, data, {merge: true});
  };

  const writeToProtokoll = () => {
    let date = new Date();

    const localDate = date.toLocaleString().replace(" ", "");

    let funkkennungAltTmp = props.fahrzeug.funkkennung;
    if (funkkennung === funkkennungAltTmp) {
      // console.log("funkkenung unverändert", props.fahrzeug);
      if (props.fahrzeug.funkkennungAlt) {
        funkkennungAltTmp = props.fahrzeug.funkkennungAlt;
      } else {
        funkkennungAltTmp = "";
      }
    }

    let funkkennungTmp = funkkennung;
    if (!needFunkkennung) {
      funkkennungTmp = "";
      funkkennungAltTmp = props.fahrzeug.funkkennung;
    }

    // console.log("updateProtokoll", props.fahrzeug);
    const data = {
      datum: "->" + localDate,
      fahrzeug: props.fahrzeug.kennzeichen,
      kennung: funkkennungTmp,
      kennungAlt: funkkennungAltTmp,
      standort: props.standort,
      status,
      bemerkung: props.bemerkung,
      // Millisekunden, unabhängig von der Locale des Browsers — so verlangt es
      // das Regelwerk, und so rechnen die Datumsfilter der Protokollseite.
      timestamp: date.getTime(),
      desDate: new Date(desDate),
      kilometerstand: kilometer,
    };

    return addDoc(protokollRef, data);
  };

  const sendNotifyEmail = (data) => {
    // console.log("sendNotifyEmail called");

    // const emailData = {
    //   emailTo: "helfrich@moinmoin-media.de",
    //   kennzeichen: data.fahrzeug,
    //   kennung: data.kennung,
    //   standort: data.standort,
    //   fzStatus: data.status,
    //   bemerkung: data.bemerkung,
    //   desDate: data.desDate,
    //   kilometerstand: data.kilometerstand,
    //   timestamp: data.timestamp,
    // };

    const emailData = {
      email: "fahrzeugUpdate",
      emailTo: "technik@rettungsdienstbremen.de",
      kennzeichen: data.fahrzeug,
      kennung: data.kennung,
      standort: data.standort,
      fzStatus: data.status,
      bemerkung: data.bemerkung,
      desDate: data.desDate,
      kilometerstand: data.kilometerstand,
      timestamp: data.timestamp,
    };

    axios
      .post("https://fleethq-email.osc-fr1.scalingo.io/api/email", emailData)
      .then(function (response) {
        // console.log(response);
      })
      .catch(function (error) {
        // console.log(error);
      });

    // axios
    //   .post("http://localhost:3000/api/email", emailData)
    //   .then(function (response) {
    //     console.log(response);
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });

    // console.log("sendNotifyEmail finished");
  };

  /**
   * Markiert die abgegebene Funkkennung als frei und die neue als belegt.
   */
  const updateFunkkennung = (funkkennungAlt, funkkennungNeu) => {
    let inUseId = "";
    let notInUseId = "";

    if (funkkennungAlt === funkkennungNeu) return;

    for (let i = 0; i < props.funkkennungen.length; i++) {
      if (funkkennungAlt === props.funkkennungen[i].bezeichnung)
        notInUseId = props.funkkennungen[i].id;
      if (funkkennungNeu === props.funkkennungen[i].bezeichnung)
        inUseId = props.funkkennungen[i].id;
    }

    if (inUseId !== "") {
      setDoc(doc(db, "funkkennungen", inUseId), {inUse: true}, {merge: true})
        .catch((error) => {
          console.log(error);
        });
    }

    if (notInUseId !== "") {
      setDoc(
        doc(db, "funkkennungen", notInUseId),
        {inUse: false},
        {merge: true},
      ).catch((error) => {
        console.log(error);
      });
    }
  };

  const handleSave = async () => {
    if (!canWrite || speichert) {
      return;
    }

    if (needFunkkennung) updateFunkkennung(props.funkkennung, funkkennung);
    else {
      updateFunkkennung(props.funkkennung, "");
    }

    setSpeichert(true);
    setSpeicherFehler("");

    try {
      await Promise.all([updateFahrzeug(), writeToProtokoll()]);
    } catch (error) {
      console.error("Fahrzeug konnte nicht gespeichert werden:", error);
      setSpeicherFehler(speicherfehlerText(error));
      setSpeichert(false);
      return;
    }

    setSpeichert(false);
    handleClose();
  };

  const handleClose = () => {
    props.closeModal();
    setSpeicherFehler("");
    setId("");
    setFunkkennung(props.funkkennung);
    setBemerkungError(true);
    setFunkkennungError(true);
    setStandortError(true);
    setBemerkungChanged(false);
  };

  const changeFunkkennung = (funkkennung) => {
    setFunkkennung(funkkennung);
  };

  // if (props.showModal) {
  //   if (id !== props.id) {
  //     setId(props.id);
  //     if (funkkennung !== props.fahrzeug.funkkennung) setFunkkennung(props.fahrzeug.funkkennung);
  //     if (standort !== props.fahrzeug.standort) setStandort(props.fahrzeug.standort);
  //   }
  // }
  // console.log("props.fahrzeug", props.fahrzeug);
  // console.log("props.fahrzeuge", props.fahrzeuge);

  return (
    <>
      <Modal show={props.showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Fahrzeugdaten bearbeiten</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="modalStatus">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                {STATUS.map((item) => (
                  <option key={item.column} value={item.column}>
                    {item.title}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Funkkennung</Form.Label>
              <Form.Select
                value={funkkennung}
                name="modalfunkkennung"
                onChange={(e) => changeFunkkennung(e.target.value)}
              >
                <option value="">Keine Funkkennung</option>
                {props.funkkennungen.map((item) => {
                  if (!item.inUse) {
                    return (
                      <option key={item.id} value={item.bezeichnung}>
                        {item.bezeichnung} (frei)
                      </option>
                    );
                  } else if (item.bezeichnung === props.funkkennung) {
                    return (
                      <option key={item.id} value={item.bezeichnung}>
                        {item.bezeichnung} (aktuell)
                      </option>
                    );
                  }

                  return null;
                })}
              </Form.Select>
            </Form.Group>
            {needFunkkennung && funkkennung === "" ? (
              <MsgBox
                msg="Es muss eine Funkkennung gewählt werden!"
                type="error"
              />
            ) : undefined}
            {!needFunkkennung && funkkennung !== "" ? (
              <MsgBox
                msg="Funkkennung wird beim Speichern entfernt!"
                type="info"
              />
            ) : undefined}
            <Form.Group className="mb-3">
              <Form.Label>Standort</Form.Label>
              <Form.Select
                value={props.standort}
                onChange={(e) => props.setStandort(e.target.value)}
              >
                <option value="">Kein Standort ausgewählt</option>
                {standorte.map((item) => {
                  return (
                    <option key={item.id} value={item.bezeichnung}>
                      {item.bezeichnung} | {item.typ}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            {needDienstort && standortTyp !== "Dienstort" ? (
              <MsgBox
                msg="Es muss ein Dienstort gewählt werden!"
                type="error"
              />
            ) : undefined}

            {props.fahrzeug.needDes === "true" ? (
              <Form.Group className="mb-3">
                <Form.Label>Letzte Grunddesinfektion</Form.Label>
                <div className="datepicker">
                  <DatePicker onChange={setDesDate} value={desDate} />
                </div>
              </Form.Group>
            ) : undefined}

            <Form.Group className="mb-3">
              <Form.Label htmlFor="inputKilomter">Kilometerstand</Form.Label>
              <Form.Control
                type="text"
                id="inputKilomter"
                value={kilometer}
                onChange={(e) => {
                  changeKm(e);
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Bemerkung</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={props.bemerkung}
                onChange={(e) => {
                  props.setBemerkung(e.target.value);
                  setBemerkungChanged(true);
                }}
              />
            </Form.Group>
            {bemerkungError && props.bemerkung !== "" ? (
              <MsgBox msg="Die Bemerkung muss angepasst werden" type="error" />
            ) : undefined}
            {props.bemerkung === "" ? (
              <MsgBox msg="Die Bemerkung darf nicht leer sein" type="error" />
            ) : undefined}
            {speicherFehler !== "" ? (
              <MsgBox msg={speicherFehler} type="error" />
            ) : undefined}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={
              !canWrite ||
              speichert ||
              funkkennungError ||
              standortError ||
              bemerkungError
            }
          >
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalFahrzeug;
